<template>
  <div class="l-container">

    <h1 class="m-label">Contract</h1>

    <div>
      <table-c>
        <tr-c slot="tr-td" v-for="(list, index) in tutor.student.contracts" :key="index.id">
          <td-c>{{list.id}}</td-c>
          <td-c>{{list.student_id}}</td-c>
          <!-- <td&#45;c>{{list.user_id}}</td&#45;c> -->
          <td-c>{{list.contract_type}}</td-c>
          <td-c>{{list.contract_date}}</td-c>
          <td-c>{{list.change_date}}</td-c>
          <td-c>{{list.cancel_date}}</td-c>
          <td-c>{{list.media}}</td-c>
          <td-c>{{list.f_name}}</td-c>
          <td-c>{{list.l_name}}</td-c>
          <td-c>{{list.f_name_kana}}</td-c>
          <td-c>{{list.l_name_kana}}</td-c>
          <td-c>{{list.tel}}</td-c>
          <td-c>{{list.tel2}}</td-c>
          <td-c>{{list.address}}</td-c>
          <td-c>{{list.address2}}</td-c>
          <!-- <td&#45;c>{{list.amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.discount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.split_commission}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.sales_commission}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.sales_commission_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.sales_commission_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.pure_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.pure_amount_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.pure_amount_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.old_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.agency_commission}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.agency_commission_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.agency_commission_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.purchase_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.purchase_amount_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.purchase_amount_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.only_total_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.only_total_amount_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.only_total_amount_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.down_payment}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.deposit_amount}}</td&#45;c> -->
          <td-c>{{list.deposit_amount_date}}</td-c>
          <td-c>{{list.office}}</td-c>
          <td-c>{{list.person}}</td-c>
          <td-c>{{list.product_name}}</td-c>
          <td-c>{{list.payment_type}}</td-c>
          <td-c>{{list.text_type}}</td-c>
          <td-c>{{list.payments_number}}</td-c>
          <td-c>{{list.text_payment_period_start}}</td-c>
          <td-c>{{list.text_payment_period_end}}</td-c>
          <td-c>{{list.service_period_start}}</td-c>
          <td-c>{{list.service_period_end}}</td-c>
          <!-- <td&#45;c>{{list.administrative_expense}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.first_month_deposit}}</td&#45;c> -->
          <td-c>{{list.first_month_deposit_method}}</td-c>
          <td-c>{{list.first_month_deposit_check}}</td-c>
          <td-c>{{list.admission_fee}}</td-c>
          <td-c>{{list.admission_fee_method}}</td-c>
          <td-c>{{list.admission_fee_check}}</td-c>
          <td-c>{{list.deposit}}</td-c>
          <td-c>{{list.deposit_check}}</td-c>
          <td-c>{{list.deposit_refund_date}}</td-c>
          <td-c>{{list.deposit_method}}</td-c>
          <td-c>{{list.approval_date}}</td-c>
          <td-c>{{list.approval_number}}</td-c>
          <td-c>{{list.delivery_date}}</td-c>
          <td-c>{{list.contract_collection_date}}</td-c>
          <td-c>{{list.factor_collection_date}}</td-c>
          <td-c>{{list.grade}}</td-c>
          <!-- <td&#45;c>{{list.point_s}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_c}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_k}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_s_bulk}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_c_bulk}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_k_bulk}}</td&#45;c> -->
          <td-c>{{list.point_total}}</td-c>
          <td-c>{{list.note}}</td-c>
          <!-- <td&#45;c>{{list.created_at}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.updated_at}}</td&#45;c> -->
        </tr-c>
      </table-c>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    tutor: Object
  },
  data () {
    return {
      edit_id: '',
      order: -1,

      search: {
        // id: '',
        // student_id: '',
        // user_id: '',
        // month: '',
        // filing_date: '',
        // note: '',
        // file_name: '',
        // created_at: '',
        // not_id: '',
        // not_student_id: '',
        // not_user_id: '',
        // not_month: '',
        // not_filing_date: '',
        // not_note: '',
        // not_file_name: '',
        // not_created_at: ''
      },

      add: {
        // id: '',
        // student_id: '',
        // user_id: '',
        // month: '',
        // filing_date: '',
        // note: '',
        // file_name: '',
        // file: ''
      }
    }
  },
  computed: {
  },
  methods: {
    // switchV (col) {
    //   this[col] = !this[col]
    // },
    //
    // reset () {
    //   this.id = false
    // },
    //
    // all () {
    //   this.id = true
    // },
    //
    // sort (header) {
    //   console.log(this.type)
    //   console.log(header)
    //   this.order = this.order * -1
    // },
    //
    // offset (e) {
    //   this.$store.dispatch('SCROLL', this, e, obj)
    // },
    //
    // searchTable (e) {
    //   this.$store.dispatch('SEARCH', this, e, obj)
    // },
    //
    // editContract (list) {
    //   this.edit_id = list.id
    // },
    //
    // postContract () {
    //   this.$store.dispatch('postContract', this.add)
    // },
    //
    // deleteContract (list) {
    //   this.$store.dispatch('deleteContract', list)
    // },
    //
    // cancelContract () {
    //   this.$store.dispatch('cancelContract', {
    //     edit_id: this.edit_id,
    //     add: this.add
    //   })
    // },
    //
    // patchContract (list) {
    //   this.$store.dispatch('patchContract', {
    //     list: list,
    //     edit_id: this.edit_id
    //   })
    // }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TutorAgreements.vue?1547f118